import styled from '@emotion/styled';
import { colors, sizes } from '@smartsheet/lodestar-core';

export const Bar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  width: 100%;
  height: 56px;

  background: ${colors.neutralLight40};
  box-shadow: inset 0px -1px 0px ${colors.neutralLight20};

  display: flex;
  align-items: center;

  padding: ${sizes.xSmall}px ${sizes.small}px;

  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
`;
